import setCookie from './setCookie'

const eraseCookie = (name: string) => {
  setCookie(name, undefined, -1)
}

export default eraseCookie
